var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ApiService } from '@app/utility/api.service';
import { UtilService } from '@app/utility/util.service';
import { Router } from '@angular/router';
import { NotiService } from '@app/noti.service';
import { TranslateService } from '@ngx-translate/core';
import { timer } from 'rxjs/observable/timer';
var RequestDocumentComponent = /** @class */ (function () {
    function RequestDocumentComponent(router, fb, util, apiService, translate, notiService) {
        this.router = router;
        this.fb = fb;
        this.util = util;
        this.apiService = apiService;
        this.translate = translate;
        this.notiService = notiService;
        this.isCompany = false;
        this.isForeign = false;
        this.submitted = false;
        this.crm03Obj = [];
        this.isConsentAccept = false;
        this.isShownConsent = false;
        this.allowNews = false;
        this.lang = "th";
        this.disablebtnSave = false;
        this.saveOK = false;
        this.showReqNewDocForm = true;
        this.showOtp = false;
        this.disableResentOtp = false;
        this.totolWaitResend = 59;
        this.telephoneOtp = "";
        this.otp = "";
        this.otpRef = "";
        this.requestOtpLbl = "ขอรหัส OTP";
        this.requestOtpLblTmp = "ขอรหัส OTP";
        this.otpTimer = "";
        this.ElapseTime = 0;
        this.TotalTime = 0;
        this.OTPCountDown = "";
        this.crm08DROSList = [];
        this.form = this.fb.group({
            dpa_companyname: "",
            dpa_companytypeid: "",
            dpa_registrationid: "",
            dpa_authorizedperson: "",
            dpa_authorizedperson_idcard: "",
            dpa_authorizedperson_telephone: "",
            contactid: "",
            firstname: ['', Validators.required],
            lastname: ['', Validators.required],
            dpa_idcard: "",
            telephone1: ['', Validators.required],
            emailaddress1: ['', this.emailValidator],
            birthdate: "",
            dpa_accountno: "",
            dpa_contact_homeno: ['', Validators.required],
            dpa_contact_moo: "",
            dpa_contact_street: "",
            dpa_contact_subdistict: "",
            dpa_contact_distict: "",
            dpa_contact_province: "",
            dpa_contact_postcode: "",
            dpa_contact_country: "",
            dpa_contact_subdistictname: "",
            dpa_contact_distictname: "",
            dpa_contact_provincname: "",
            dpa_contact_postcodename: "",
            dpa_contact_countryname: "",
            dpa_allowemail: false,
            dpa_allowsms: false,
            dpa_portalflag: true,
            pid: ""
        });
    }
    RequestDocumentComponent.prototype.ngOnDestroy = function () {
        if (this.notiSubscription) {
            this.notiSubscription.unsubscribe();
        }
    };
    RequestDocumentComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            function matchCustom(params, data) {
                // If there are no search terms, return all of the data
                if ($.trim(params.term) === '') {
                    return data;
                }
                // Do not display the item if there is no 'text' property
                if (typeof data.text === 'undefined') {
                    return null;
                }
                if (params.term.length > 1) {
                    // `params.term` should be the term that is used for searching
                    // `data.text` is the text that is displayed for the data object
                    var cris = params.term.split(" ");
                    var found = true;
                    for (var i = 0; i < cris.length; i++) {
                        if (cris[i] != '' && data != null && data.text != null && data.text.toLowerCase().indexOf(cris[i].toLowerCase()) < 0) {
                            found = false;
                            return null;
                        }
                    }
                    if (found) {
                        // You can return modified objects from here
                        // This includes matching the `children` how you want in nested data sets
                        return data;
                    }
                }
                // Return `null` if the term should not be displayed
                return null;
            }
            var thisTs, PortalUser, _a, _b, _c, _d, hasrow, _i, _e, itm, reqdetail, firstname, lastname, name_1, i;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        thisTs = this;
                        PortalUser = JSON.parse(localStorage.getItem("dpa_portal"));
                        if (PortalUser == null || PortalUser.contactid == null || PortalUser.contactid == "") {
                            this.util.WarningDialog("กรุณาเข้าสู่ระบบ");
                            $("#btnWarningOK").off("click");
                            $("#btnWarningOK").click(function () {
                                thisTs.router.navigate(["/mainmenu/login"]);
                            });
                            return [2 /*return*/];
                        }
                        this.util.ShowWaiting(true);
                        if (this.lang == "th") {
                            $(".select2-en").hide();
                            $(".select2-th").show();
                        }
                        else {
                            $(".select2-th").hide();
                            $(".select2-en").show();
                        }
                        this.notiSubscription = this.notiService.message.subscribe(function (_lang) {
                            _this.lang = _lang;
                            if (_this.lang == "th") {
                                $(".select2-en").hide();
                                $(".select2-th").show();
                            }
                            else {
                                $(".select2-th").hide();
                                $(".select2-en").show();
                            }
                            if (_this.contact != null) {
                                $(".select2").val(_this.contact.dpa_contact_subdistict + "|" + _this.contact.dpa_contact_distict + "|" + _this.contact.dpa_contact_province + "|" + _this.contact.dpa_contact_postcode + "|" + _this.contact.dpa_contact_country).trigger('change');
                            }
                            //this.bindAddress(this.lang)
                        });
                        this.cookieData = JSON.parse(localStorage.getItem("dpa_portal"));
                        if (this.cookieData == null) {
                            this.cookieData = {};
                        }
                        $('.select2th').select2({
                            matcher: matchCustom,
                            placeholder: "โปรดพิมพ์รายละเอียดที่อยู่"
                        });
                        $('.select2en').select2({
                            matcher: matchCustom,
                            placeholder: "Please select your address."
                        });
                        $(".select2").on("change", function (e) {
                            thisTs.addressChange(e.target.value);
                        });
                        return [4 /*yield*/, this.initdropdown()];
                    case 1:
                        _f.sent();
                        _a = this;
                        return [4 /*yield*/, this.getContact()];
                    case 2:
                        _a.contact = _f.sent();
                        if (!(this.contact.dpa_companytypeid != null && this.contact.dpa_companytypeid.trim().length > 0)) return [3 /*break*/, 4];
                        _b = this;
                        return [4 /*yield*/, this.getContactDROS(this.contact.dpa_registrationid)];
                    case 3:
                        _b.contactDROS = _f.sent();
                        return [3 /*break*/, 8];
                    case 4:
                        if (!(this.contact.dpa_passport != null && this.contact.dpa_passport.trim().length > 0)) return [3 /*break*/, 6];
                        _c = this;
                        return [4 /*yield*/, this.getContactDROS(this.contact.dpa_passport)];
                    case 5:
                        _c.contactDROS = _f.sent();
                        return [3 /*break*/, 8];
                    case 6:
                        _d = this;
                        return [4 /*yield*/, this.getContactDROS(this.contact.dpa_idcard)];
                    case 7:
                        _d.contactDROS = _f.sent();
                        _f.label = 8;
                    case 8:
                        hasrow = false;
                        if (!this.util.IsNullOrUndefined(this.contactDROS.CRM03)) {
                            for (_i = 0, _e = this.contactDROS.CRM03; _i < _e.length; _i++) {
                                itm = _e[_i];
                                if (!this.util.IsNullOrUndefined(itm.FilePath)) {
                                    if (itm.FilePath.split('_')[1] != "05.pdf" && itm.FilePath.split('_')[1] != "07.pdf") {
                                        if (itm.IsPrint != 1) {
                                            hasrow = true;
                                        }
                                        reqdetail = {
                                            RequestedNo: itm.RequestedNo,
                                            RequestType: itm.RequestType,
                                            isPrintMessage: itm.IsPrint == 1 ? "มีการขอเอกสารแล้ว" : ("สามารถขอเอกสารได้"),
                                            UID: itm.UID,
                                            isPrint: itm.IsPrint,
                                        };
                                        this.crm03Obj.push(reqdetail);
                                    }
                                }
                            }
                        }
                        if (!hasrow) {
                            this.disablebtnSave = true;
                            //$("#savedata").addClass("sr-only");
                        }
                        if (!this.util.IsNullOrUndefined(this.crm03Obj) && this.crm03Obj.length == 0) {
                            $("#divNoData").removeClass("colhidden");
                            //$("#savedata").addClass("sr-only");
                            this.disablebtnSave = true;
                        }
                        if (this.cookieData != null) {
                            this.contact.pid = this.cookieData.pid;
                        }
                        this.mapDataToForm(this.contact);
                        $(".select2").val(this.contact.dpa_contact_subdistict + "|" + this.contact.dpa_contact_distict + "|" + this.contact.dpa_contact_province + "|" + this.contact.dpa_contact_postcode + "|" + this.contact.dpa_contact_country).trigger('change');
                        this.allowNews = this.contact.dpa_allowemail || this.contact.dpa_allowsms;
                        if (this.contact != null && this.contact.birthdate != null && this.contact.birthdate.trim().length != 0) {
                            $("#dob").datepicker("setDate", new Date(this.contact.birthdate));
                        }
                        if (this.contact.dpa_companytypeid != null && this.contact.dpa_companytypeid.trim().length > 0) {
                            this.isCompany = true;
                            firstname = "";
                            lastname = "";
                            try {
                                name_1 = this.contact.dpa_authorizedperson.split(" ");
                                if (name_1.length > 0) {
                                    if (name_1.length == 1) {
                                        firstname = name_1[0];
                                    }
                                    else if (name_1.length == 2) {
                                        firstname = name_1[0];
                                        lastname = name_1[1];
                                    }
                                    else {
                                        for (i = 0; i < name_1.length - 1; i++) {
                                            firstname += " " + name_1[i];
                                        }
                                        firstname = firstname.trim();
                                        lastname = name_1[name_1.length - 1];
                                    }
                                }
                            }
                            catch (e) {
                                console.log(e);
                            }
                            this.form.controls["firstname"].setValue(firstname);
                            this.form.controls["lastname"].setValue(lastname);
                        }
                        else {
                            this.isForeign = this.contact != null && this.contact.dpa_passport != null && this.contact.dpa_passport.trim() != '';
                        }
                        $('#chkboxAll').click(function () {
                            var $that = $(this);
                            $(':checkbox').each(function () {
                                this.checked = $that.is(':checked');
                            });
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    RequestDocumentComponent.prototype.goToClick = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var accNo, thisTs, PortalUser, _a, _b, _c, _i, _d, itm, docStatus, rowDisplay, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        this.crm08DROSList = [];
                        accNo = event.target.id;
                        //localStorage.setItem('acccountNo', accNo);
                        //this.router.navigate(["/mainmenu/statusReqNewDocument"]);
                        this.lang = this.util.GetCurrentLang();
                        thisTs = this;
                        PortalUser = JSON.parse(localStorage.getItem("dpa_portal"));
                        if (PortalUser == null || PortalUser.contactid == null || PortalUser.contactid == "") {
                            this.util.WarningDialog("กรุณาเข้าสู่ระบบ");
                            $("#btnWarningOK").off("click");
                            $("#btnWarningOK").click(function () {
                                thisTs.router.navigate(["/mainmenu/login"]);
                            });
                            return [2 /*return*/];
                        }
                        this.util.ShowWaiting(true);
                        this.cookieData = JSON.parse(localStorage.getItem("dpa_portal"));
                        if (this.cookieData == null) {
                            this.cookieData = {};
                        }
                        _a = this;
                        return [4 /*yield*/, this.getContact()];
                    case 1:
                        _a.contact = _f.sent();
                        _b = this;
                        return [4 /*yield*/, this.getContactDROS(this.contact.dpa_idcard)];
                    case 2:
                        _b.contactDROS = _f.sent();
                        if (!!this.util.IsNullOrUndefined(this.contactDROS.CRM06)) return [3 /*break*/, 4];
                        _c = this;
                        return [4 /*yield*/, this.getCRM08DROS(this.contactDROS.CRM06.UID)];
                    case 3:
                        _c.crm08DROS = _f.sent();
                        if (!this.util.IsNullOrUndefined(this.crm08DROS) && this.crm08DROS.length > 0) {
                            for (_i = 0, _d = this.crm08DROS; _i < _d.length; _i++) {
                                itm = _d[_i];
                                if (itm.DROSRequestNo == accNo) {
                                    docStatus = void 0;
                                    if (itm.SentStatus === "1") {
                                        docStatus = "ส่งสำเร็จ";
                                    }
                                    else if (itm.PrintStatus === "1") {
                                        docStatus = "อยู่ระหว่างจัดพิมพ์";
                                    }
                                    else if (itm.IsRead === "1") {
                                        docStatus = "ได้รับข้อมูล";
                                    }
                                    else {
                                        docStatus = "ยื่นคำขอเอกสารใหม่";
                                    }
                                    rowDisplay = { CRMRequestNo: itm.CRMRequestNo, DROSRequestNo: itm.DROSRequestNo, DocumentCode: itm.DocumentCode, UID: itm.UID, Status: itm.Status, ErrorCode: itm.ErrorCode, Address: itm.Address, MooNo: itm.MooNo, StreetName: itm.StreetName, LocationCode: itm.LocationCode, Zipcode: itm.Zipcode, PhoneNo: itm.PhoneNo, Email: itm.Email, CreateOn: this.DisplayDate(itm.CreateOn), ModifiedOn: itm.ModifiedOn, ProcessStatus: docStatus };
                                    this.crm08DROSList.push(rowDisplay);
                                }
                            }
                        }
                        _f.label = 4;
                    case 4:
                        _e = this;
                        return [4 /*yield*/, this.getAddressAll()];
                    case 5:
                        _e.combinedAddressList = _f.sent();
                        this.util.ShowWaiting(false);
                        $("#frmStatusReqNewDoc").removeClass("hideDiv").addClass("animate-opacity");
                        return [2 /*return*/];
                }
            });
        });
    };
    RequestDocumentComponent.prototype.getCRM08DROS = function (uid) {
        return __awaiter(this, void 0, void 0, function () {
            var para, tmp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        para = "UID=" + uid;
                        return [4 /*yield*/, this.apiService.get("crmservice", "getCRM08DROS", para)];
                    case 1:
                        tmp = _a.sent();
                        return [2 /*return*/, tmp];
                }
            });
        });
    };
    RequestDocumentComponent.prototype.getAddressAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tmp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiService.getMasterAddress()];
                    case 1:
                        tmp = _a.sent();
                        return [2 /*return*/, tmp];
                }
            });
        });
    };
    RequestDocumentComponent.prototype.DisplayDate = function (sdate) {
        var result = "";
        var enDate = sdate.split('T')[0].split('-');
        if (this.lang === "th-TH") {
            result = enDate[2] + "/" + enDate[1] + "/" + (parseInt(enDate[0]) + 543).toString();
        }
        else {
            result = enDate[2] + "/" + enDate[1] + "/" + enDate[0];
        }
        return result;
    };
    RequestDocumentComponent.prototype.initdropdown = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.apiService.getMasterAddress()];
                    case 1:
                        _a.combinedAddressList = _b.sent();
                        this.setAddressEn();
                        if (this.contact != null) {
                            $(".select2").val(this.contact.dpa_contact_subdistict + "|" + this.contact.dpa_contact_distict + "|" + this.contact.dpa_contact_province + "|" + this.contact.dpa_contact_postcode + "|" + this.contact.dpa_contact_country).trigger('change');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    RequestDocumentComponent.prototype.setAddressEn = function () {
        if (this.combinedAddressList != null && this.combinedAddressList.length > 0) {
            this.combinedAddressListEn = this.combinedAddressList.slice().sort(function (a, b) {
                if (a.text_eng < b.text_eng) {
                    return -1;
                }
                if (a.text_eng > b.text_eng) {
                    return 1;
                }
                return 0;
            });
        }
    };
    Object.defineProperty(RequestDocumentComponent.prototype, "formControl", {
        get: function () {
            return this.form.controls;
        },
        enumerable: true,
        configurable: true
    });
    RequestDocumentComponent.prototype.addressChange = function (value) {
        var selected = this.combinedAddressList.filter(function (a) { return a.id == value; });
        if (selected != null && selected.length > 0) {
            var values = selected[0].id.split("|");
            var texts = void 0;
            if (this.lang == "th") {
                texts = selected[0].text.split(" | ");
            }
            else {
                texts = selected[0].text_eng.split(" | ");
            }
            this.formControl["dpa_contact_subdistict"].setValue(values[0]);
            this.formControl["dpa_contact_distict"].setValue(values[1]);
            this.formControl["dpa_contact_province"].setValue(values[2]);
            this.formControl["dpa_contact_postcode"].setValue(values[3]);
            this.formControl["dpa_contact_country"].setValue(values[4]);
            this.formControl["dpa_contact_subdistictname"].setValue(texts[0]);
            this.formControl["dpa_contact_distictname"].setValue(texts[1]);
            this.formControl["dpa_contact_provincname"].setValue(texts[2]);
            this.formControl["dpa_contact_postcodename"].setValue(texts[3]);
            this.formControl["dpa_contact_countryname"].setValue(texts[4]);
        }
        else {
            this.formControl["dpa_contact_subdistict"].setValue("");
            this.formControl["dpa_contact_distict"].setValue("");
            this.formControl["dpa_contact_province"].setValue("");
            this.formControl["dpa_contact_postcode"].setValue("");
            this.formControl["dpa_contact_country"].setValue("");
            this.formControl["dpa_contact_subdistictname"].setValue("");
            this.formControl["dpa_contact_distictname"].setValue("");
            this.formControl["dpa_contact_provincname"].setValue("");
            this.formControl["dpa_contact_postcodename"].setValue("");
            this.formControl["dpa_contact_countryname"].setValue("");
        }
    };
    RequestDocumentComponent.prototype.emailValidator = function (control) {
        if (control.value) {
            var matches = control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/);
            return matches ? null : { 'invalidEmail': true };
        }
        else {
            return null;
        }
    };
    RequestDocumentComponent.prototype.CheckFormAndOTP = function () {
        return __awaiter(this, void 0, void 0, function () {
            var selected;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submitted = true;
                        if (!this.form.valid) {
                            return [2 /*return*/, false];
                        }
                        selected = [];
                        $("#tbcrm03 input[type=checkbox]:checked").each(function () {
                            var row = $(this).closest("tr")[0];
                            selected.push(row.cells[1].innerHTML);
                        });
                        if (selected.length == 0) {
                            this.util.ErrorDialog("กรุณาเลือกเอกสารอย่างน้อย 1 รายการ");
                            return [2 /*return*/, false];
                        }
                        //this.telephoneOtp = this.isCompany ? this.form.get("dpa_authorizedperson_telephone").value : this.form.get("telephone1").value;
                        //$("#frmReqNewDoc").hide();
                        //this.showOtp = true;
                        return [4 /*yield*/, this.save()];
                    case 1:
                        //this.telephoneOtp = this.isCompany ? this.form.get("dpa_authorizedperson_telephone").value : this.form.get("telephone1").value;
                        //$("#frmReqNewDoc").hide();
                        //this.showOtp = true;
                        _a.sent();
                        if (this.saveOK) {
                            this.util.SuccessDialog("บันทึกข้อมูลสำเร็จ");
                            $("#btnSuccessOK").click(function () {
                                return __awaiter(this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        window.location.reload();
                                        return [2 /*return*/];
                                    });
                                });
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    RequestDocumentComponent.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var selected, dataSave, _i, selected_1, itm, rowSave;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        selected = [];
                        dataSave = [];
                        $("#tbcrm03 input[type=checkbox]:checked").each(function () {
                            var row = $(this).closest("tr")[0];
                            var rowCRM03 = {
                                reqNoDROS: row.cells[1].innerHTML,
                                UID: row.cells[4].innerHTML
                            };
                            selected.push(rowCRM03);
                        });
                        for (_i = 0, selected_1 = selected; _i < selected_1.length; _i++) {
                            itm = selected_1[_i];
                            rowSave = {
                                CRMRequestNo: "",
                                DROSRequestNo: itm.reqNoDROS,
                                DocumentCode: "",
                                UID: itm.UID,
                                Status: "P",
                                ErrorCode: "",
                                Address: this.form.get("dpa_contact_homeno").value,
                                MooNo: this.form.get("dpa_contact_moo").value,
                                StreetName: this.form.get("dpa_contact_street").value,
                                LocationCode: this.form.get("dpa_contact_subdistict").value,
                                Zipcode: this.form.get("dpa_contact_postcodename").value,
                                PhoneNo: this.isCompany ? this.form.get("dpa_authorizedperson_telephone").value : this.form.get("telephone1").value,
                                Email: this.form.get("emailaddress1").value,
                                IsRead: "",
                                PrintStatus: "",
                                SentStatus: "",
                                CreateOn: "",
                                ModifiedOn: ""
                            };
                            dataSave.push(rowSave);
                        }
                        return [4 /*yield*/, this.apiService.post("crmservice", "UpdateCRM08DROS", dataSave).then(function (res) {
                                if (res != null && res["Status"] != null && parseInt(res["Status"]) == 200) {
                                    //let thisTs = this
                                    _this.saveOK = true;
                                }
                                else if (res != null && res["Status"] != null && parseInt(res["Status"]) == 201) {
                                    _this.util.WarningDialog("บันทึกข้อมูลไม่สำเร็จ มีคำขอซ้ำในระบบ");
                                }
                                else {
                                    _this.util.ErrorDialog("บันทึกข้อมูลไม่สำเร็จ");
                                }
                                _this.util.ShowWaiting(false);
                            })];
                    case 1:
                        _a.sent();
                        this.clearFrmOTP();
                        return [2 /*return*/];
                }
            });
        });
    };
    RequestDocumentComponent.prototype.close = function () {
        //window.close()
        this.router.navigate(["/mainmenu/index"]);
    };
    RequestDocumentComponent.prototype.telephoneOnly = function (event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            if (charCode == 35 || charCode == 44) {
                return true;
            }
            return false;
        }
        return true;
    };
    RequestDocumentComponent.prototype.numberOnly = function (event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    };
    RequestDocumentComponent.prototype.getContact = function () {
        return __awaiter(this, void 0, void 0, function () {
            var para, tmp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        para = "contactid=" + this.cookieData.contactid;
                        return [4 /*yield*/, this.apiService.get("crmservice", "contact", para)];
                    case 1:
                        tmp = _a.sent();
                        return [2 /*return*/, tmp[0]];
                }
            });
        });
    };
    RequestDocumentComponent.prototype.getContactDROS = function (idcard) {
        return __awaiter(this, void 0, void 0, function () {
            var para, tmp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        para = "dpa_id=" + idcard + "&telephoneno=&fullname=&CRM05=false&CRM04=false&CRM03=true&CRM02=false&CRM07=false";
                        return [4 /*yield*/, this.apiService.get("crmservice", "contactDros", para)];
                    case 1:
                        tmp = _a.sent();
                        return [2 /*return*/, tmp];
                }
            });
        });
    };
    RequestDocumentComponent.prototype.mapDataToForm = function (data) {
        var _this = this;
        Object.keys(data).forEach(function (key) {
            if (_this.form.controls[key]) {
                _this.form.controls[key].setValue(data[key]);
            }
            else {
                _this.form.addControl(key, new FormControl(data[key]));
            }
        });
        setTimeout(function () {
            _this.util.ShowWaiting(false);
        }, 600);
    };
    RequestDocumentComponent.prototype.isValidForm = function () {
        return true;
    };
    RequestDocumentComponent.prototype.onCheckChange = function () {
        var totalCheckboxes = $('#tbcrm03 input:checkbox').length;
        var numberOfChecked = $('#tbcrm03 input:checkbox:checked').length;
        if (totalCheckboxes === numberOfChecked) {
            $('#chkboxAll').prop('checked', true);
        }
        else {
            $('#chkboxAll').prop('checked', false);
        }
    };
    RequestDocumentComponent.prototype.cancelOtp = function () {
        $("#frmReqNewDoc").show();
        this.clearFrmOTP();
        this.showOtp = false;
    };
    RequestDocumentComponent.prototype.requestOtp = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var reqOtp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.util.ShowWaiting(true);
                        reqOtp = {
                            MobileNo: this.telephoneOtp,
                        };
                        return [4 /*yield*/, this.apiService.postCustomApi("crm", "RequestOTP", reqOtp).then(function (reqOtpRes) { return __awaiter(_this, void 0, void 0, function () {
                                var _this = this;
                                var smsContent, sendSms, sendSmsRes;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!this.util.isSuccessResponse(reqOtpRes)) return [3 /*break*/, 2];
                                            smsContent = "รหัสตรวจสอบการยืนยันตัวตนของคุณคือ : ";
                                            smsContent += reqOtpRes.otpNo + " ";
                                            smsContent += "(RefCode : " + reqOtpRes.RefCode;
                                            smsContent += " ) (รหัสมีอายุ " + reqOtpRes.expInMinute + " นาที) อย่าเปิดเผยรหัสกับผู้อื่น";
                                            sendSms = {
                                                dpa_description: smsContent,
                                                dpa_phoneno: this.telephoneOtp
                                            };
                                            return [4 /*yield*/, this.apiService.post("crmservice", "sendSms", sendSms)];
                                        case 1:
                                            sendSmsRes = _a.sent();
                                            this.util.ShowWaiting(false);
                                            if (this.util.isSuccessResponse(sendSmsRes)) {
                                                $("#divOtp").removeClass("colhidden");
                                                this.otpRef = reqOtpRes.RefCode;
                                                this.otpTimer = 59;
                                                this.lastReqTime = new Date();
                                                this.requestOtpLblTmp = "ส่งอีกครั้ง";
                                                this.swithLbl();
                                                this.disableResentOtp = true;
                                                this.countdown();
                                                if (reqOtpRes.expInMinute == undefined || reqOtpRes.expInMinute == null) {
                                                    this.TotalTime = 300;
                                                }
                                                else {
                                                    this.TotalTime = reqOtpRes.expInMinute * 60;
                                                }
                                                this.ElapseTime = 0;
                                                if (this.SubScr != undefined) {
                                                    this.SubScr.unsubscribe();
                                                }
                                                this.SubScr = timer(0, 1000).subscribe(function () { return _this.CountDownOTP(); });
                                            }
                                            else {
                                                this.util.ErrorDialog("เกิดข้อผิดพลาดในการ ขอ Otp กรุณาลองใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่");
                                            }
                                            return [3 /*break*/, 3];
                                        case 2:
                                            this.util.ShowWaiting(false);
                                            this.util.ErrorDialog("เกิดข้อผิดพลาดในการ ขอ Otp กรุณาลองใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่");
                                            _a.label = 3;
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RequestDocumentComponent.prototype.swithLbl = function () {
        if (this.requestOtpLblTmp == "ขอรหัส OTP") {
            var lblTmp = this.translate.get("RequestOTP");
            this.requestOtpLbl = lblTmp.value;
        }
        else {
            var lblTmp = this.translate.get("ResendOTP");
            this.requestOtpLbl = lblTmp.value;
        }
    };
    RequestDocumentComponent.prototype.countdown = function () {
        var _this = this;
        if (this.otpTimer > 0) {
            var dif = new Date().getTime() - this.lastReqTime.getTime();
            var Seconds_from_T1_to_T2 = dif / 1000;
            this.otpTimer = this.totolWaitResend - Math.round(Seconds_from_T1_to_T2);
            setTimeout(function () {
                _this.countdown();
            }, 400);
        }
        else {
            this.disableResentOtp = false;
        }
    };
    RequestDocumentComponent.prototype.CountDownOTP = function () {
        if (this.ElapseTime == 0 && this.TotalTime == 0) {
            this.SubScr.unsubscribe();
            this.OTPCountDown = "";
            return;
        }
        if (this.ElapseTime == this.TotalTime) {
            this.SubScr.unsubscribe();
            this.ElapseTime = 0;
            this.OTPCountDown = "";
            return;
        }
        this.ElapseTime++;
        var RemainingSecs = this.TotalTime - this.ElapseTime;
        var RemainingMins = (RemainingSecs - (RemainingSecs % 60)) / 60;
        RemainingSecs = RemainingSecs % 60;
        this.OTPCountDown = " " + RemainingMins + ":" + (RemainingSecs < 10 ? "0" : "") + RemainingSecs;
    };
    RequestDocumentComponent.prototype.clearFrmOTP = function () {
        this.otp = "";
        this.otpRef = "";
        this.otpTimer = 0;
        if (!this.util.IsNullOrUndefined(this.SubScr)) {
            this.SubScr.unsubscribe();
        }
        this.ElapseTime = 0;
        this.OTPCountDown = "";
        this.requestOtpLbl = "ขอรหัส OTP";
        this.requestOtpLblTmp = "ขอรหัส OTP";
        $("#divOtp").addClass("colhidden");
        return;
    };
    RequestDocumentComponent.prototype.SubmitOTP = function () {
        return __awaiter(this, void 0, void 0, function () {
            var reqCheckOtp, reqCheckOtpRes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.otp.trim().length > 0)) return [3 /*break*/, 7];
                        this.util.ShowWaiting(true);
                        reqCheckOtp = {
                            OTP: this.otp.trim(),
                            RefCode: this.otpRef,
                            MobileNo: this.telephoneOtp
                        };
                        return [4 /*yield*/, this.apiService.postCustomApi("crm", "VerifyOTP", reqCheckOtp)];
                    case 1:
                        reqCheckOtpRes = _a.sent();
                        if (!!this.util.IsNullOrUndefined(reqCheckOtpRes)) return [3 /*break*/, 5];
                        if (!reqCheckOtpRes.IsValid) return [3 /*break*/, 3];
                        $("#frmReqNewDoc").show();
                        this.showOtp = false;
                        return [4 /*yield*/, this.save()];
                    case 2:
                        _a.sent();
                        if (this.saveOK) {
                            window.location.reload();
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        this.util.ShowWaiting(false);
                        this.util.WarningDialog("รหัส OTP ที่ท่านกรอกไม่ถูกต้อง");
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        this.util.ShowWaiting(false);
                        this.util.WarningDialog("พบข้อผิดพลาดในการยืนยันรหัส OTP กรูณาลองใหม่อีกครั้งหรือติดต่อเจ้าหน้าที่");
                        _a.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        this.util.WarningDialog("กรุณาระบุรหัส OTP");
                        _a.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    RequestDocumentComponent.prototype.ShowDetail = function (drosReqNo) {
        var objDetail = this.crm08DROSList.find(function (e) { return e.DROSRequestNo === drosReqNo; });
        if (!this.util.IsNullOrUndefined(objDetail.ErrorMessage)) {
            this.util.WarningDialog(objDetail.ErrorMessage);
        }
        var addr = this.combinedAddressList.filter(function (a) { return a.id.split('|')[0] == objDetail.LocationCode; });
        $("#lblFullname").empty().text(this.contactDROS.CRM06.Name);
        $("#lblPhoneNo").empty().text(objDetail.PhoneNo);
        $("#lblDROSReqNo").empty().text(objDetail.DROSRequestNo);
        var fullAdress = "";
        if (!this.util.IsNullOrUndefined(objDetail.Address)) {
            fullAdress += objDetail.Address;
        }
        if (!this.util.IsNullOrUndefined(objDetail.MooNo)) {
            fullAdress += " หมู่ที่ " + objDetail.MooNo;
        }
        if (!this.util.IsNullOrUndefined(objDetail.StreetName)) {
            fullAdress += " ถนน" + objDetail.StreetName;
        }
        if (addr.length > 0) {
            var tmpAddr = addr[0].text.split('|');
            for (var i = 0; i < tmpAddr.length; i++) {
                if (i == 0) {
                    fullAdress += " แขวง/ตำบล " + tmpAddr[i];
                }
                if (i == 1) {
                    fullAdress += " เขต/อำเภอ " + tmpAddr[i];
                }
                if (i == 2) {
                    fullAdress += " จังหวัด" + tmpAddr[i];
                }
                if (i == 3) {
                    fullAdress += tmpAddr[i] == objDetail.Zipcode ? " ไปรษณีย์ " + tmpAddr[i] : " ไปรษณีย์ " + objDetail.Zipcode;
                }
                if (i == 4) {
                    fullAdress += " ประเทศ " + tmpAddr[i];
                }
            }
        }
        $("#lblAddress").empty().text(fullAdress);
        var progress1 = '<li class="active step0"><img id="imgStatus01" class="img-fluid" width="101" style="background-color: white;" src="../../assets/images/icon_inprogress1.png"><br><span style="color: black;">ได้รับคำขอ</span>  </li> ';
        var progress2 = '<li class="active step0"><img id="imgStatus02" class="img-fluid" width="101" style="background-color: white;"  src="../../assets/images/icon_inprogress2.png"><br><span style="color: black;">อยู่ระหว่างจัดทำเอกสาร</span>   </li>';
        var progress3 = '<li class="active step0"><img id="imgStatus03" class="img-fluid" width="101" style="background-color: white;"  src="../../assets/images/icon_inprogress3.png"><br><span style="color: black;">ดำเนินการจัดส่งเอกสาร</span>   </li>';
        switch (objDetail.ProcessStatus) {
            case "ส่งสำเร็จ": {
                var li = progress1 + progress2 + progress3;
                $("#progressbarimg").append(li);
                $("#imgStatus01").attr("src", "../../assets/images/circle_1.png");
                $("#imgStatus02").attr("src", "../../assets/images/circle_1.png");
                $("#imgStatus03").attr("src", "../../assets/images/checked.png");
                break;
            }
            case "อยู่ระหว่างจัดพิมพ์": {
                var li = progress1 + progress2;
                $("#progressbarimg").append(li);
                $("#imgStatus01").attr("src", "../../assets/images/circle_1.png");
                $("#imgStatus02").attr("src", "../../assets/images/checked.png");
                //$("#imgStatus03").attr("src", "../../assets/images/icon_inprogress3.png");
                break;
            }
            case "ยื่นคำขอเอกสารใหม่":
            case "ได้รับข้อมูล": {
                $("#progressbarimg").append(progress1);
                $("#imgStatus01").attr("src", "../../assets/images/checked.png");
                //$("#imgStatus02").attr("src", "../../assets/images/icon_inprogress2.png");
                // $("#imgStatus03").attr("src", "../../assets/images/icon_inprogress3.png");
                break;
            }
            default: {
                $("#progressbarimg").append(progress1);
                $("#imgStatus01").attr("src", "../../assets/images/circle.png");
                //$("#imgStatus02").attr("src", "../../assets/images/icon_inprogress2.png");
                //$("#imgStatus03").attr("src", "../../assets/images/icon_inprogress3.png");
                break;
            }
        }
        $("#frmStatusReqNewDoc").removeClass("animate-opacity").addClass("hideDiv");
        $("#divDetail").removeClass("hideDiv").addClass("animate-opacity");
        //console.log(objDetail);
        // console.log(this.contactDROS.CRM06);
    };
    RequestDocumentComponent.prototype.BackToList = function () {
        $("#divDetail").removeClass("animate-opacity").addClass("hideDiv");
        $("#frmStatusReqNewDoc").removeClass("hideDiv").addClass("animate-opacity");
    };
    return RequestDocumentComponent;
}());
export { RequestDocumentComponent };



// WEBPACK FOOTER //
// ./src/app/request-document/request-document.component.ts.pre-build-optimizer.js